import api from '../../utils/api';
import history from '../../utils/history';
import { SHOPIFY_RETAILERS_LOADING, SHOPIFY_RETAILERS_REDIRECT_URI } from '../constants/shopifyTypes';
import { alertError } from './alert';

const REQUIRED_QUERY = ['hmac', 'shop', 'timestamp'];

function isRequiredQueryParametersExist(params) {
  return REQUIRED_QUERY.every((key) => !!params.get(key));
}

async function getRedirectUrl(search) {
  return api.get(`/shopify/auth?${search}`);
}

export const validateAndGetGrantPageUrl = (search) => async (dispatch) => {
  dispatch({ type: SHOPIFY_RETAILERS_LOADING, payload: { redirectUrl: true } });

  const params = new URLSearchParams(search);
  if (!isRequiredQueryParametersExist(params)) {
    return dispatch(alertError('Missing params in request, please try again.'));
  }

  try {
    const response = await getRedirectUrl(params);
    if (response.data && response.status === 200) {
      const { url: redirectUrl, updatingScopesOnly } = response.data;
      if (redirectUrl) {
        dispatch({
          type: SHOPIFY_RETAILERS_REDIRECT_URI,
          payload: {
            redirectUrl,
            updatingScopesOnly,
          },
        });
        return;
      }

      history.push('/');
    } else {
      dispatch(alertError(`Couldn't get redirect url to Shopify`));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export function redirectToShopify({ url, shouldOpenInNewWindow = false }) {
  if (!shouldOpenInNewWindow) {
    window.top.location.replace(url);
    return;
  }

  const left = (window.screen.width - 1000) / 2;
  const top = (window.screen.height - 600) / 2;
  window.open(
    url,
    '_blank',
    `popup,resizeable,scrollbars,width=1000,height=600,noopener,noreferrer,left=${left},top=${top}`,
  );
}
